import { useState, useEffect, useRef, useCallback } from 'react';

export const useDebounce = (data: string, delay: number): string => {
  const [debouncedValue, setDebouncedValue] = useState<string>('');

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(data);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [delay, data]);

  return debouncedValue;
};

export const useDebounceFn = (
  delay: number
): ((callback: () => unknown) => void) => {
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const handler = useCallback(
    (callback: () => unknown) => {
      clearTimeout(timer.current);
      timer.current = setTimeout(callback, delay);
    },
    [delay]
  );

  return handler;
};
